/* Opens the desktop header dropdowns on hover.

   Dawn's <header-menu> is a <details> that only opens on click. On a device
   with a real pointer we open it on mouseenter and close it shortly after the
   pointer leaves both the label and its panel; the delay bridges the gap
   between them. Touch and keyboard keep the click / Enter behaviour, so the
   menu still works without a hover-capable pointer.

   Setting/removing the `open` attribute fires the native toggle event, which
   Dawn's HeaderMenu already listens to, so no other code needs to know. */
(() => {
  const hoverable = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  const CLOSE_DELAY = 180;

  const init = () => {
    const menus = Array.from(document.querySelectorAll('.header__inline-menu header-menu'));
    if (!menus.length) return;

    const closeAll = (except) => {
      menus.forEach((m) => {
        if (m === except) return;
        const d = m.querySelector('details');
        if (d && d.open) {
          d.removeAttribute('open');
          d.querySelector('summary').setAttribute('aria-expanded', 'false');
        }
      });
    };

    menus.forEach((menu) => {
      const details = menu.querySelector('details');
      const summary = details && details.querySelector('summary');
      if (!details || !summary) return;
      let timer;

      const open = () => {
        if (!hoverable.matches) return;
        clearTimeout(timer);
        closeAll(menu);
        if (!details.open) {
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
        }
      };

      const scheduleClose = () => {
        if (!hoverable.matches) return;
        clearTimeout(timer);
        timer = setTimeout(() => {
          // Keyboard users tabbing inside the panel keep it open.
          if (menu.contains(document.activeElement) && document.activeElement.matches(':focus-visible')) return;
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }, CLOSE_DELAY);
      };

      menu.addEventListener('mouseenter', open);
      menu.addEventListener('mouseleave', scheduleClose);

      // A mouse click on a label that hover already opened must not close it.
      // event.detail is 0 for keyboard-triggered clicks, which still toggle.
      summary.addEventListener('click', (event) => {
        if (hoverable.matches && event.detail > 0) event.preventDefault();
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
